<template>
  <div class="app-container">
    <div class="mycontainer" style="margin-bottom: 0px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="80px"
        :rules="rules"
      >
        <el-form-item label="周报日期">
          <el-date-picker
            v-model="time"
            type="week"
            size="small"
            style="width: 200px"
            format="yyyy 第 WW 周"
            placeholder="选择周"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="分公司：" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="listQuery.bmbh"
            placeholder="选择分公司"
            clearable
            filterable
            multiple
            collapse-tags
            size="small"
            style="width: 200px"
            class="filter-item"
            @change="handleChangeBm"
            :disabled="isFgs"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="区域总监" prop="qyzj">
          <el-select
            ref="qyzj"
            v-model="listQuery.qyzj"
            placeholder="全部"
            clearable
            filterable
            size="small"
            multiple
            class="filter-item"
            @change="handleChangeQyzj"
            style="width: 200px"
          >
            <el-option
              v-for="item in areaDirectorList"
              :key="item.xm"
              :label="item.xm"
              :value="item.ygbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="listQuery.xmbh"
            placeholder="选择项目"
            clearable
            filterable
            multiple
            collapse-tags
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmmc"
              :value="item.xmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList()"
            >查询</el-button
          >
          <el-button
            icon="el-icon-download"
            size="small"
            @click="exportZbtsnr()"
            style="margin-left: 4px"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        border
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="分公司"
          prop="bmmc"
          min-width="100px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="周报日期"
          prop="zbrq"
          min-width="120px"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="项目名称"
          prop="xmmc"
          min-width="150px"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="区域总监"
          prop="qyzj"
          min-width="80px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="周报提交人"
          prop="zbtjr"
          min-width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="推送编辑内容"
          prop="work"
          min-width="150px"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="goDocDetail(scope.row.url)"
              v-if="scope.row.name"
            >
              <span>{{ scope.row.name }}</span>
            </el-button>
            <div v-else>{{ scope.row.work }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="推送编辑提交人"
          prop="tstjr"
          min-width="100px"
          align="center"
        >
        </el-table-column>

        <el-table-column
          label="推送编辑时间"
          prop="tsbjsj"
          min-width="120px"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>
  
<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { getZbtsnrList, exportZbtsnr } from "@/api/reportQuery.js";
import "moment/locale/zh-cn";
import { getAreaDirectorList } from "@/api/xmReview.js";
import { getBmxxList } from "@/api/itWeekly";
import { getXmxx } from "@/api/xmcbhs.js";
import { mapGetters } from "vuex";
import { formatMomentDate } from "@/utils/utils";
import moment, { weekdays } from "moment";
import "moment/locale/zh-cn";
export default {
  // 列表分页
  name: "jsqxmList",
  components: { Pagination },
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    // const rolesAllClass = [{ value: 0, name: '超级管理员' }, { value: 1, name: '普通管理员' }, { value: 2, name: '普通员工' }, { value: 3, name: '普通用户' }]
    return {
      height: 100,
      listQuery: {
        bmbh: [],
        xmbh: [],
        qyzj: [],
        page: 1,
        pageSize: 50,
      },
      data2: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        htlx: "0", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        htzt: "1,3", //合同状态，多个,隔开，如1,3
      },
      value: "",
      time: "",
      pickerOptions: {
        firstDayOfWeek: 1,
      },
      isQyzj: false,
      isFgs: false,
      listLoading: false,
      total: 0,
      list: [],
      bmList: [],
      areaDirectorList: [],
      xmList: [],
      rules: {},
      mxParams: {},
    };
  },
  created() {
    getBmxxList(this.data2.type, this.data2.range).then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });

    this.$store.dispatch("common/fetchUserInfoAction").then((res) => {
      if (this.user.bmmc.indexOf("分公司") > -1) {
        this.isFgs = true;
        this.listQuery.bmbh.push(this.user.bmbh);
        this.getAreaDirectorList({ bmbh: this.user.bmbh });
        this.getXmxx(this.user.bmbh, "");
      } else {
        this.getAreaDirectorList({ bmbh: "" });
        this.getXmxx("", "");
      }
      this.getList();
    });

    this.weekCheckingIn();
  },
  methods: {
    getAreaDirectorList(bmbh) {
      getAreaDirectorList(bmbh).then((res) => {
        if (res.code == 0) {
          this.areaDirectorList = res.data;
        }
      });
    },
    getXmxx(bmbh, qyzj) {
      getXmxx(bmbh, qyzj).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
        }
      });
    },

    getCurrentYearFirst() {
      var date = new Date();
      let nowYear = date.getFullYear();
      var date1 = new Date(nowYear, 0, 1);
      return date1;
    },
    handleChangeBm(i) {
      this.listQuery.qyzj = [];
      const bmbh = this.listQuery.bmbh.join(",");
      const qyzj = this.listQuery.qyzj.join(",");
      this.getAreaDirectorList({ bmbh });
      this.getXmxx(bmbh, qyzj);
    },
    handleChangeQyzj(i) {
      const bmbh = this.listQuery.bmbh.join(",");
      const qyzj = this.listQuery.qyzj.join(",");
      this.getXmxx(bmbh, qyzj);
    },
    getList() {
      const qsrq = moment(this.time).startOf("week").format("YYYYMMDD");
      const jsrq = moment(this.time).endOf("week").format("YYYYMMDD");
      const time = `${qsrq}-${jsrq}`;
      this.listLoading = true;
      const bmbh = this.listQuery.bmbh.join(",");
      const xmbh = this.listQuery.xmbh.join(",");
      const qyzj = this.listQuery.qyzj.join(",");
      getZbtsnrList({
        ...this.listQuery,
        qsrq,
        jsrq,
        time,
        bmbh,
        xmbh,
        qyzj,
      }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 75;
        } else {
          this.listLoading = false;
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    goDocDetail(url) {
      // 在这里处理跳转逻辑，例如打开一个新窗口或者直接跳转页面
      window.open(url, "_blank"); // 在新窗口打开URL
    },

    weekCheckingIn() {
      var now = new Date();
      var nowTime = now.getTime();
      var day = now.getDay() || 7; // 不加 || 7.周末会变成下周一
      var oneDayTime = 24 * 60 * 60 * 1000;
      var MondayTime = nowTime - (day - 1) * oneDayTime; //显示周一
      //调用方法
      this.time = new Date(MondayTime);
    },

    exportZbtsnr() {
      const qsrq = moment(this.time).startOf("week").format("YYYYMMDD");
      const jsrq = moment(this.time).endOf("week").format("YYYYMMDD");
      const time = `${qsrq}-${jsrq}`;
      const bmbh = this.listQuery.bmbh.join(",");
      const xmbh = this.listQuery.xmbh.join(",");
      const qyzj = this.listQuery.qyzj.join(",");
      exportZbtsnr({
        ...this.listQuery,
        qsrq,
        jsrq,
        time,
        bmbh,
        xmbh,
        qyzj,
      }).then((res) => {
        if (res.code == 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}
#save-form .el-form-item {
  margin-bottom: 20px;
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
</style>

